(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-chatbot"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ai-chatbot').forEach(function(section) {
    var messages = Array.from(section.querySelectorAll('.ai-chatbot__msg'));
    var typingDots = section.querySelector('.ai-chatbot__typing');
    var replayBtn = section.querySelector('.ai-chatbot__replay');
    var msgContainer = section.querySelector('.ai-chatbot__messages');
    var srLive = section.querySelector('.ai-chatbot__sr-live');
    var started = false;

    if (messages.length === 0) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    messages.forEach(function(msg) {
      msg.dataset.fullText = msg.textContent.trim();
      msg.textContent = '';
    });

    function scrollToBottom() {
      msgContainer.scrollTop = msgContainer.scrollHeight;
    }

    function announce(text) {
      srLive.textContent = '';
      void srLive.offsetWidth;
      srLive.textContent = text;
    }

    function typeText(el, text, speed, onDone) {
      var i = 0;
      var interval = setInterval(function() {
        el.textContent += text[i];
        i++;
        scrollToBottom();
        if (i >= text.length) {
          clearInterval(interval);
          if (onDone) onDone();
        }
      }, speed);
    }

    function playMessage(index) {
      if (index >= messages.length) {
        replayBtn.style.display = 'block';
        return;
      }
      var msg = messages[index];
      var speaker = msg.dataset.speaker;
      var text = msg.dataset.fullText;

      if (speaker === 'bot') {
        typingDots.style.display = 'flex';
        scrollToBottom();
        setTimeout(function() {
          typingDots.style.display = 'none';
          msg.style.display = 'block';
          typeText(msg, text, 25, function() {
            announce(text);
            setTimeout(function() { playMessage(index + 1); }, 600);
          });
        }, 1200);
      } else {
        msg.style.display = 'block';
        typeText(msg, text, 15, function() {
          announce(text);
          setTimeout(function() { playMessage(index + 1); }, 400);
        });
      }
    }

    function startConversation() {
      if (started) return;
      started = true;
      playMessage(0);
    }

    function resetConversation() {
      messages.forEach(function(msg) {
        msg.textContent = '';
        msg.style.display = 'none';
      });
      typingDots.style.display = 'none';
      replayBtn.style.display = 'none';
      started = false;
      startConversation();
    }

    replayBtn.addEventListener('click', resetConversation);

    if (!window.IntersectionObserver) {
      startConversation();
    } else {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            startConversation();
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.announcement-bar').forEach(function (bar) {
      if (reducedMotion) return;

      var messages = bar.querySelectorAll('.announcement-bar__message');
      if (messages.length < 2) return;

      var speed = parseInt(bar.dataset.rotationSpeed, 10) || 5000;
      var current = 0;

      // No clearInterval teardown — acceptable for standard Shopify navigation.
      // If turbo/instant-page is ever added, this interval will leak on route changes.
      // Fix at that point by storing the id and clearing on page:before-render.
      setInterval(function () {
        messages[current].classList.remove('announcement-bar__message--active');
        messages[current].setAttribute('aria-hidden', 'true');
        current = (current + 1) % messages.length;
        messages[current].classList.add('announcement-bar__message--active');
        messages[current].removeAttribute('aria-hidden');
      }, speed);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var delta = parseInt(btn.dataset.qtyChange, 10);
        var index = btn.dataset.index;
        var input = document.querySelector('.cart-item__qty-input[data-index="' + index + '"]');
        if (!input) return;
        var newVal = Math.max(0, parseInt(input.value, 10) + delta);
        input.value = newVal;
        document.getElementById('cart-form').submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var toggle = document.querySelector('.collection-sidebar__toggle');
    var nav = document.getElementById('sidebar-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var trigger = document.getElementById('cat-drawer-trigger');
    var drawer  = document.getElementById('cat-drawer');
    var overlay = document.getElementById('cat-drawer-overlay');
    var closeBtn = document.getElementById('cat-drawer-close');

    if (!trigger || !drawer) return;

    function openDrawer() {
      drawer.removeAttribute('hidden');
      requestAnimationFrame(function() {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      });
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function() {
        drawer.setAttribute('hidden', '');
      }, 300);
      trigger.focus();
    }

    trigger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.hero-carousel').forEach(function(carousel) {
      var track = carousel.querySelector('.hero-carousel__track');
      var dots = carousel.querySelectorAll('.hero-carousel__dot');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');

      var slides = carousel.querySelectorAll('.hero-carousel__slide');
      var total = slides.length;
      if (total <= 1) return;

      var speed = parseInt(carousel.dataset.speed, 10) || 6000;
      var autoplay = carousel.dataset.autoplay !== 'false';
      var current = 0;
      var timer = null;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      function manageVideos(activeIndex) {
        slides.forEach(function(slide, i) {
          var vid = slide.querySelector('[data-slide-video]');
          if (!vid) return;
          if (i === activeIndex) {
            vid.play().catch(function() {});
          } else {
            vid.pause();
            vid.currentTime = 0;
          }
        });
      }

      function goTo(n) {
        if (dots.length) {
          dots[current].classList.remove('hero-carousel__dot--active');
          dots[current].setAttribute('aria-selected', 'false');
        }
        current = (n + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        if (dots.length) {
          dots[current].classList.add('hero-carousel__dot--active');
          dots[current].setAttribute('aria-selected', 'true');
        }
        manageVideos(current);
      }

      manageVideos(0);

      function startAuto() {
        clearInterval(timer);
        if (!autoplay) return;
        timer = setInterval(function() { goTo(current + 1); }, speed);
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); startAuto(); });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.slide, 10));
          startAuto();
        });
      });

      startAuto();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    /* ── Thumbnail swap ── */
    var mainImg = document.getElementById('pdp-main-image');
    if (mainImg) {
      document.querySelectorAll('[data-thumb-index]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          mainImg.src = btn.dataset.src;
          document.querySelectorAll('[data-thumb-index]').forEach(function(b) {
            b.classList.remove('pdp__thumb--active');
          });
          btn.classList.add('pdp__thumb--active');
        });
      });
    }

    /* ── Quantity stepper ── */
    var qtyInput = document.getElementById('pdp-quantity');
    if (qtyInput) {
      document.querySelectorAll('[data-qty]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var delta = parseInt(btn.dataset.qty, 10);
          var newVal = Math.max(1, parseInt(qtyInput.value, 10) + delta);
          qtyInput.value = newVal;
        });
      });
    }

    /* ── Variant price update ── */
    var variantSelect = document.getElementById('pdp-variant-select');
    var priceEl = document.getElementById('pdp-price');
    var comparePriceEl = document.getElementById('pdp-compare-price');
    var atcBtn = document.getElementById('pdp-atc-btn');

    if (variantSelect && priceEl) {
      variantSelect.addEventListener('change', function() {
        var selected = variantSelect.options[variantSelect.selectedIndex];
        var price = parseInt(selected.dataset.price, 10);
        var comparePrice = parseInt(selected.dataset.comparePrice, 10);
        var available = selected.dataset.available === 'true';

        priceEl.textContent = formatMoney(price);

        if (comparePriceEl) {
          if (comparePrice && comparePrice > price) {
            comparePriceEl.textContent = formatMoney(comparePrice);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (atcBtn) {
          atcBtn.disabled = !available;
          atcBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
          atcBtn.classList.toggle('pdp__atc-btn--sold-out', !available);
        }

        /* update hidden id input */
        var hiddenId = document.getElementById('pdp-variant-id');
        if (hiddenId) hiddenId.value = selected.value;
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.reviews-carousel').forEach(function (carousel) {
      var wrapper       = carousel.querySelector('.reviews-carousel__track-wrapper');
      var track         = carousel.querySelector('.reviews-carousel__track');
      var slides        = carousel.querySelectorAll('.reviews-card');
      var dotsContainer = carousel.querySelector('.reviews-carousel__dots');
      var dots          = carousel.querySelectorAll('.reviews-carousel__dot');
      var prevBtn       = carousel.querySelector('.reviews-carousel__prev');
      var nextBtn       = carousel.querySelector('.reviews-carousel__next');
      var total         = slides.length;

      if (!track || total < 1) return;

      var speed         = parseInt(carousel.dataset.speed, 10) || 5000;
      var autoplay      = carousel.dataset.autoplay !== 'false';
      var current       = 0;
      var timer         = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ── sizing helpers ── */
      function cardsPerView() {
        return window.innerWidth >= 768 ? 3 : 1;
      }

      function trackGap() {
        /* reads 1.5rem → px from live CSS; returns 0 if gap is 'normal' */
        var raw = window.getComputedStyle(track).columnGap;
        return raw === 'normal' ? 0 : (parseFloat(raw) || 0);
      }

      function cardWidth() {
        var cpv = cardsPerView();
        var gap = trackGap();
        return (wrapper.offsetWidth - (cpv - 1) * gap) / cpv;
      }

      function stepWidth() {
        /* distance the track moves per step = one card + one gap */
        return cardWidth() + trackGap();
      }

      function isNeeded()  { return total > cardsPerView(); }
      function maxIndex()  { return Math.max(0, total - cardsPerView()); }

      /* ── move to slide n (wraps within valid range) ── */
      function goTo(n) {
        var max   = maxIndex();
        var range = max + 1;
        var next  = max === 0 ? 0 : ((n % range) + range) % range;

        /* update dot states */
        if (dots[current]) {
          dots[current].classList.remove('reviews-carousel__dot--active');
          dots[current].setAttribute('aria-selected', 'false');
        }
        current = next;
        if (dots[current]) {
          dots[current].classList.add('reviews-carousel__dot--active');
          dots[current].setAttribute('aria-selected', 'true');
        }

        /* move track: n × (one card width + one gap) in pixels */
        track.style.transform = 'translateX(-' + (current * stepWidth()) + 'px)';

        /* mark the visible window [current, current + cardsPerView) as not hidden */
        var cpv = cardsPerView();
        slides.forEach(function (slide, i) {
          var visible = i >= current && i < current + cpv;
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }

      /* ── setup: runs on init and after every debounced resize ── */
      function setup() {
        var needed = isNeeded();
        var max    = maxIndex();

        /* show/hide dots container */
        if (dotsContainer) {
          dotsContainer.style.display = needed ? '' : 'none';
        }

        /* show only the dots that correspond to valid positions (0…max) */
        dots.forEach(function (dot, i) {
          dot.style.display = (needed && i <= max) ? '' : 'none';
        });

        /* clamp current to new max before repositioning */
        if (current > max) current = max;
        goTo(current);

        /* when carousel is inactive, clean up aria-hidden from all slides */
        if (!needed) {
          slides.forEach(function (slide) { slide.removeAttribute('aria-hidden'); });
        }

        /* restart autoplay at new breakpoint */
        stopAuto();
        if (needed) startAuto();
      }

      /* ── autoplay ── */
      function startAuto() {
        if (reducedMotion || !autoplay || !isNeeded()) return;
        clearInterval(timer);
        timer = setInterval(function () { goTo(current + 1); }, speed);
      }

      function stopAuto() { clearInterval(timer); }

      /* ── dot clicks ── */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.slide, 10));
          startAuto();
        });
      });

      /* ── prev/next arrow clicks ── */
      if (prevBtn) prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        startAuto();
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        goTo(current + 1);
        startAuto();
      });

      /* ── keyboard: left/right arrows anywhere in carousel ── */
      carousel.addEventListener('keydown', function (e) {
        if (!isNeeded()) return;
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        goTo(e.key === 'ArrowRight' ? current + 1 : current - 1);
        startAuto();
        if (dots[current]) dots[current].focus();
      });

      /* ── pause on hover ── */
      carousel.addEventListener('mouseenter', stopAuto);
      carousel.addEventListener('mouseleave', function () {
        if (isNeeded()) startAuto();
      });

      /* ── pause when keyboard focus is inside; resume when it leaves ── */
      carousel.addEventListener('focusin', stopAuto);
      carousel.addEventListener('focusout', function (e) {
        if (!carousel.contains(e.relatedTarget) && isNeeded()) startAuto();
      });

      /* ── resize: debounced 150ms, then full recompute ── */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setup, 150);
      });

      /* ── init ── */
      setup();
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
